<template>
    <BaseView :ignoreOffline="true">
        <template v-slot:top>
            <Navigation :is-on-free-plan="isOnFreePlan" />
        </template>


        <div v-pull-to-refresh="refreshIssues">
            <div v-if="issues.length === 0" class="middle-of-page">
                {{ $t("No issue to solve") }}
            </div>
            <div v-for="todo in issues" :key="todo.id">
                <IssueCard
                    :title="todo.issue.title"
                    :payload="todo.issue.payload"
                    :status="todo.issue.status"
                    :priority="todo.issue.priority"
                    :due-at="todo.due_at"
                    @click.native="todoIssueClicked(todo.issue)"
                />
            </div>
        </div>

        <template v-slot:bottom>
            <bottom-navigation />
        </template>
    </BaseView>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import IssueCard from '@mobile/views/Issues/Items/Issue.vue';
import Loader from '@mobile/components/Loader.vue';
import BaseView from '@mobile/components/BaseView.vue';
import { TODO_TYPE } from '@/constants';
import Navigation from './components/Navigation';
import { eventBus } from '@/eventBus';
import OnFreePlan from '@mobile/mixins/OnFreePlan';

export default {
    components: {
        Loader,
        IssueCard,
        Navigation,
        BaseView,
    },
    mixins: [OnFreePlan],
    props: {
        todoId: {
            type: String,
            default: null,
        },
    },

    created() {
        this.refreshIssues();
    },

    data: () => ({
        selectedTodo: null,
    }),

    computed: {
        ...mapGetters({
            issues: 'todos/issues',
        }),

        isIssueModalOpened() {
            return (
                this.selectedTodo && this.selectedTodo.type === TODO_TYPE.ISSUE
            );
        },
    },

    methods: {
        ...mapActions({
            updateAll: 'todos/updateAll',
        }),

        todoIssueClicked({ id }) {
            this.$router.push({ name: 'issues-edit', params: { id } });
        },

        modalClosed() {
            this.selectedTodo = null;
        },

        refreshIssues() {
            return this
                .updateAll()
                .then(() => {
                    eventBus.$emit('loaded');
                })
                .catch((error) => {
                    eventBus.$emit('client-error', error);
                });
        },
    },
};
</script>
